export default function () {
  // TODO check this when using es6 arrow functions

  // Make Password visible
  $('.js-show-pw').on('click touch', function () {
    $($(this).data('target')).attr('type') === 'password'
      ? $($(this).data('target')).attr('type', 'text')
      : $($(this).data('target')).attr('type', 'password');
  });

  (function ($) {
    /**
     * calculate a rough estimate of a passwords strength
     * @param {string} password
     * @return {int}
     */
    function _calculateScore(password) {
      let score = 0;
      //if password bigger than 6 give 1 point
      if (password.length >= 6) {
        score++;
      }
      //if password has both lower and uppercase characters give 1 point
      if (password.match(/[a-z]/) && password.match(/[A-Z]/)) {
        score++;
      }
      //if password has at least one number give 1 point
      if (password.match(/\d+/)) {
        score++;
      }
      //if password has at least one special character give 1 point
      if (password.match(/.[!,@#$%^&*?_~()-]/)) {
        score++;
      }
      //if password bigger than 12 give another 1 point
      if (password.length > 12) {
        score++;
      }
      return score;
    }

    /**
     * Custom jQuery plugin for a password strength check
     *
     * @function apnPasswordStrength
     * @memberOf jQuery.fn
     * @usage '$('#password').apnPasswordStrength([{message_elem: '#here-goes-the-output'}])
     * automatically set up for all input with a data-checkpasswordstrength="1" attribute
     * Output goes to the first found of:
     *   - the 'message_elem' in the options-object
     *   - the object in the 'data-passwordstrengthmessage'-attribute
     *   - an element with the id "<id-of-the-input>-strength"
     */
    $.fn.apnPasswordStrength = function (options) {
      const settings = $.extend(
        {
          descriptions: ['zu einfach', 'sehr einfach', 'einfach', 'mittel', 'stark', 'sehr stark'],
        },
        options,
      );
      return this.each(function () {
        const $self = $(this);
        let msg;
        if (settings.message_elem) {
          msg = settings.message_elem;
        } else if ($self.data('passwordstrengthmessage')) {
          msg = $self.data('passwordstrengthmessage');
        } else {
          msg = $('#' + this.id + '-strength');
        }
        $(this).on('keyup', function () {
          const score = _calculateScore($self.val());
          msg
            .html(settings.descriptions[score])
            .removeClass('strength0 strength1 strength2 strength3 strength4 strength5')
            .addClass('strength' + score)
            .show();
        });
      });
    };
    $('input[data-checkpasswordstrength]').apnPasswordStrength();
  })(jQuery);
}
